/**
 * Investidores Institucionais — Page script
 * Importa apenas os módulos necessários para esta página
 */

import { initAOS }             from '../modules/UI/aos-init.js';
import { initHero }             from '../modules/UI/hero.js';
import { initSplitSections }    from '../modules/Components/split-section.js';
import { initFundCarousel }     from '../modules/Components/fund-carousel.js';
import { initColumnsSlider }    from '../modules/Components/columns-slider.js';
import { initSplitSlider }      from '../modules/Components/split-slider.js';
import { initTeamList }          from '../modules/Components/team-list.js';
import { initNewsletter }       from '../modules/Components/newsletter.js';
import { initSectionConteudos } from '../modules/Components/section-conteudos.js';

function init() {
	initAOS();
	initHero();
	initSplitSections();
	initFundCarousel();
	initColumnsSlider();
	initSplitSlider();
	initTeamList();
	initNewsletter();
	initSectionConteudos();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
